import { AfterViewInit, Component, ElementRef, Renderer2 } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthenticationService } from '@app/core';
import { AnimatedModalComponent } from '@app/shared/modals/animated-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AffiliateService } from '@app/core/affiliate.service';
import { HttpClient } from '@angular/common/http';
import { ModalService } from '@app/shared/modal.service';

@Component({
  selector: 'app-affiliate-modal',
  template: `
    <div (click)="reject()" class="icon close-popup"><i class="fal fa-times"></i></div>
    <h5>{{ 'affiliate_popup.headline' | translate }}<br />{{ 'affiliate_popup.sub_headline' | translate }}</h5>
    <p *ngIf="person !== ''">
      [{{ person }}] <span>{{ 'affiliate_popup.text_1' | translate }}</span>
    </p>
    <p [innerHTML]="'affiliate_popup.text_2' | translate"></p>
    <app-form-button class="full-width primary __ga__btn-guest-welcome" (click)="closeAndRegister()">
      Register
    </app-form-button>
  `,
  providers: [AffiliateService],
})
export class ModalAffiliateComponent extends AnimatedModalComponent implements AfterViewInit {
  form: FormGroup;
  loading = false;
  errors = null;
  person: any = '';
  _service: ModalService;

  constructor(
    private ref: NgbActiveModal,
    private formBuilder: FormBuilder,
    private auth: AuthenticationService,
    protected elRef: ElementRef,
    protected renderer: Renderer2,
    protected router: Router,
    protected activatedRoute: ActivatedRoute,
    protected affiliateService: AffiliateService,
    protected http: HttpClient
  ) {
    super(elRef, renderer);
  }

  ngAfterViewInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['go']) {
        this.affiliateService.getCampaign(params['go']).subscribe(data => {
          const result = JSON.parse(data.text());
          if (result != null) {
            this.person = result.name;
          }
        });
      }
    });
  }

  public close(): void {
    this.auth.guestWon = true;
    this.ref.close(0);
  }

  public reject(): void {
    this.auth.guestWon = true;
    this.ref.dismiss(1);
  }

  public closeAndRegister() {
    this.close();
    this.router.navigate(['/v2']);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/affiliate-modal.component.ts